import React, { useMemo } from 'react';
import classnames from 'classnames';
import MultipleSelector, { MulSelectorProps } from '../../MultipleSelector';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getOptions } from '../utils';

import '../index.scss';

import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';

interface IMultipleSourceSelectProps extends IBaseProps, MulSelectorProps {
  entityType?: IGameType;
  isShowButtonLabel?: boolean;
  sources: string[];
}

const MultipleSourceSelector: React.FC<IMultipleSourceSelectProps> = (props) => {
  const {
    style,
    className,
    overlayStyle,
    overlayClassName,
    disabled,
    entityType = 'mobile',
    isShowButtonLabel = true,
    sources,
    value,
    onChange,
  } = props;

  const { locale, formatMessage } = useIntlExtend();

  const rankingText = formatMessage({ id: 'dbi_ranking' }) as string;

  const options = useMemo(() => getOptions(entityType, sources, formatMessage), [locale, sources]);

  return (
    <MultipleSelector
      style={style}
      className={classnames('dbi-single-source-select search-item', className)}
      overlayStyle={overlayStyle}
      overlayClassName={classnames('dbi-single-source-select-overlay', overlayClassName)}
      hasAllCheck={true}
      disabled={disabled}
      isShowButtonLabel={isShowButtonLabel}
      buttonName={rankingText}
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default MultipleSourceSelector;
